import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

/**
 * If the `skipParams` object contains a truthy value for `categoryTree`,
 * the function will skip clearing cache related to category trees.
 * Otherwise, it clears all cache.
 *
 */
export function clearRhinoCache(skipParams?: Record<'categoryTree', boolean>) {
  if (skipParams?.categoryTree) {
    queryClient.removeQueries({
      predicate: (query) =>
        query.queryKey[0] !== queryKeys.categoryTree[0] &&
        query.queryKey[0] !== queryKeys.categoryTreeUidas([])[0] &&
        query.queryKey[0] !== queryKeys.configuration[0],
    });
  } else {
    queryClient.removeQueries({
      predicate: (query) => query.queryKey[0] !== queryKeys.configuration[0],
    });
  }
}
